import {Observable, combineLatest, BehaviorSubject} from 'rxjs';
import {distinctUntilChanged, filter, map, startWith, shareReplay} from 'rxjs/operators';
import {uiMsg$} from '@/ui';
import {tradePair$} from '@/state/trade-pair';
import type {TradePair, TradeType} from '@/types';
import {QtyType} from '@/enum/order';

export interface FUOrderBookDepth {
  type: 'order-book-depth';
  depth: number;
}

export const bookDepth$: Observable<number> = uiMsg$.pipe(
  filter((o) => o.type === 'order-book-depth'),
  map((o: FUOrderBookDepth) => o.depth),
  startWith(10)
);

// 固定30tick深度，用于计算book百分比
export const fixationBookDepth$ = new BehaviorSubject<number>(30);

export interface FUOrderBookType {
  type: 'order-book-type';
  percentType: string;
}
export const percentType$: Observable<string> = uiMsg$.pipe(
  filter((o) => o.type === 'order-book-type'),
  map((o: FUOrderBookType) => o.percentType),
  startWith('Stack')
);

export interface FUBookStepSize {
  type: 'book-step-size';
  tradeType: TradeType;
  stepSizeEx: number;
}
const contractStepSizeEx$ = uiMsg$.pipe(
  filter((o) => o.type === 'book-step-size' && ['Perpetual', 'PerpetualV2'].indexOf(o.tradeType) > -1),
  map((o: FUBookStepSize) => o.stepSizeEx),
  startWith(0)
);

const spotStepSizeEx$ = uiMsg$.pipe(
  filter((o) => o.type === 'book-step-size' && o.tradeType === 'Spot'),
  map((o: FUBookStepSize) => o.stepSizeEx),
  startWith(0)
);

export interface FUContractQtyType {
  type: 'contract-qty-type';
  qtyType: QtyType;
}
export const contractQtyType$ = uiMsg$.pipe(
  filter((o) => o.type === 'contract-qty-type'),
  map((o: FUContractQtyType) => o.qtyType),
  startWith('ByCont'),
  shareReplay(1)
);

export const stepSizeEx$ = combineLatest([tradePair$, contractStepSizeEx$, spotStepSizeEx$]).pipe(
  map(convertStepSizeEx),
  distinctUntilChanged()
);

function convertStepSizeEx([tradePair, contractStepSizeEx, spotStepSizeEx]: [TradePair, number, number]) {
  if (tradePair.type === 'Spot') {
    return spotStepSizeEx;
  }
  if (['Perpetual', 'PerpetualV2'].indexOf(tradePair.type) > -1) {
    return contractStepSizeEx;
  }
  return 0;
}
